import api from "../../../../lib/api";
import {
  ICustomerVasBulkPayload,
  ICustomerVasCreate,
  ICustomerVasGetByIdPayload,
  ICustomerVasListSearch,
  ICustomerValueAddedServicesPayload,
  IEditCustomerVasPayload,
} from "../../../../types/master/customerVasInterface";

export const createCustomerVasApi = async (data: ICustomerVasCreate) => {
  return await api.post("/customer/vas-rules/", data);
};

export const getCustomerVasFormDataApi = async (customerId: number | string) => {
  return await api.get(`/customer/vas-rules/form-data/${customerId}`);
};

export const getCustomerValueAddedServicesApi = async (customerId: number | string) => {
  return await api.get(`/customer/value-added-services/${customerId}`);
};

export const updateCustomerValueAddedServicesApi = async (payload: ICustomerValueAddedServicesPayload) => {
  return await api.put("/customer/value-added-services", payload);
};

export const bulkSyncCustomerVasApi = async (payload: ICustomerVasBulkPayload) => {
  return await api.put("/customer/vas-rules/bulk", payload);
};

const buildCustomerVasListParams = (data: ICustomerVasListSearch) => {
  const params: Record<string, string | number | boolean> = {
    customer_id: data.customer_id,
  };

  if (data.search_key) {
    params.search_key = data.search_key;
  }
  if (data.vas_type_id != null) {
    params.vas_type_id = data.vas_type_id;
  }
  if (data.is_active != null && data.is_active !== "") {
    params.is_active = data.is_active;
  }

  return params;
};

export const getCustomerVasListApi = async (data: ICustomerVasListSearch) => {
  return await api.get(`/customer/vas-rules/${data.page}/${data?.pageLimit ?? 10}`, {
    params: buildCustomerVasListParams(data),
  });
};

export const getCustomerVasDataByIdApi = async (payload: ICustomerVasGetByIdPayload) => {
  return await api.get(`/customer/vas-rules/id/${payload.id}`, {
    params: { customer_id: payload.customer_id },
  });
};

export const editCustomerVasDataByIdApi = async (payload: IEditCustomerVasPayload) => {
  return await api.put(`/customer/vas-rules/id/${payload.id}`, payload.data, {
    params: { customer_id: payload.customer_id },
  });
};

export const getCustomerVasTypeDropdownApi = async (data?: { page?: number; search?: string }) => {
  return await api.get("/dropdowns/vas-types/0/25", {
    params: { search: data?.search ?? "" },
  });
};

export const getCustomerVasRateBasisDropdownApi = async (data?: { page?: number; search?: string }) => {
  return await api.get("/dropdowns/vas-rate-basis/0/25", {
    params: { search: data?.search ?? "" },
  });
};
